export default __webpack_public_path__ + "static/media/Asset-Mainpage.c3489483.png";